import React from 'react';
import COLORS from '../theme/colors';

// Estilos base compartidos por las tres variantes — mantiene el tamaño
// y la forma consistentes sin importar la jerarquía visual del botón.
const baseStyle = {
  padding: '8px 16px',
  borderRadius: '4px',
  fontSize: '0.9rem',
  cursor: 'pointer',
};

// Jerarquía visual: relleno sólido (primaria) > outline neutro (secundaria) > outline rojo (destructiva).
// El peso del relleno es lo que comunica prioridad, no solo el color.
const VARIANTS = {
  primary: {
    backgroundColor: COLORS.teal,
    color: COLORS.white,
    border: 'none',
    fontWeight: '600',
  },
  secondary: {
    backgroundColor: COLORS.white,
    color: COLORS.charcoal,
    border: '1px solid #d1d5db',
  },
  danger: {
    backgroundColor: 'transparent',
    color: '#c0392b',
    border: '1px solid #c0392b',
    fontWeight: '500',
  },
};

/**
 * @description Botón reutilizable con jerarquía visual explícita (primary/secondary/danger).
 * Nace para reemplazar los <button> sin estilo propio repetidos en cada página del panel
 * (Projects.js es el primer caso resuelto; otras páginas migrarán a este componente
 * a medida que se les aplique el mismo fix).
 * @param {'primary'|'secondary'|'danger'} [variant='secondary'] Jerarquía visual del botón.
 * @param {object} [style] Estilos adicionales que se mergean sobre la variante (ej. márgenes de layout).
 */
const Button = ({ variant = 'secondary', style, children, ...rest }) => (
  <button style={{ ...baseStyle, ...VARIANTS[variant], ...style }} {...rest}>
    {children}
  </button>
);

export default Button;
